import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { VerificationService } from '../../services/verification.service';
import { DataService } from '../../services/data.service';
import { SpinnerService } from '../../services/spinner.service';
import { ButtonComponent } from '../../shared/reusable/button/button.component';
import { VerificationStatus } from '../../models/verification-status.model';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  imports: [CommonModule, ButtonComponent],
  standalone: true,
})
export class SummaryComponent implements OnInit {
  status = signal<VerificationStatus | null>(null);
  completing = signal<boolean>(false);

  constructor(
    private authService: AuthService,
    private verificationService: VerificationService,
    private dataService: DataService,
    private spinner: SpinnerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const returnToken = this.route.snapshot.queryParamMap.get('return_token');
    if (returnToken) {
      this.processSignaturaReturn(returnToken);
    } else {
      this.loadStatus();
    }
  }

  private processSignaturaReturn(token: string): void {
    this.spinner.show();
    this.verificationService.validateSignaturaReturn(token).subscribe({
      next: () => {
        this.spinner.hide();
        // Remove return_token from URL without navigating away
        this.router.navigate([], { queryParams: {}, replaceUrl: true });
        this.loadStatus();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error procesando return de Signatura', err);
        // Aún así cargar el status — puede que ya esté completado por el webhook
        this.loadStatus();
      }
    });
  }

  loadStatus(): void {
    const code = this.authService.getVerificationCode();
    if (!code) {
      alert('Código de verificación no encontrado');
      return;
    }

    this.verificationService.getStatus(code).subscribe({
      next: (response) => {
        this.status.set(response.data);
        this.dataService.setVerificationStatus(response.data);
      },
      error: (err) => {
        alert('Error al cargar el estado de verificación');
        console.error(err);
      }
    });
  }

  complete(): void {
    const code = this.authService.getVerificationCode();
    if (!code) return;

    this.completing.set(true);
    this.spinner.show();

    this.verificationService.complete(code).subscribe({
      next: () => {
        this.spinner.hide();
        this.completing.set(false);
        alert('¡Verificación completada con éxito!');
        this.authService.logout();
      },
      error: (err) => {
        this.spinner.hide();
        this.completing.set(false);
        alert('Error al completar la verificación');
        console.error(err);
      }
    });
  }
}
